import React from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import Manufacturing from "../../Images/(Manufacturing)-Investment_Pg.webp";
import ICT from "../../Images/(ICT)-Investment_Pg.webp";
import RealEstate from "../../Images/(Real_Estate)-Investment_Pg.webp";
import Construction from "../../Images/(Construction)-Investment_Pg.webp";
import PartnershipSection from "./PartnershipSection";
import ProjectInquirySection from "./ProjectInquirySection";

const InvestmentOpportunities = () => {
  const investmentOpportunities = [
    {
      id: 1,
      title: "Manufacturing",
      image: Manufacturing,
      className: "col-span-1 row-span-1",
    },
    {
      id: 2,
      title: "Real Estate",
      image: RealEstate,
      className: "col-span-1 row-span-1",
    },
    {
      id: 3,
      title: "Construction",
      image: Construction,
      className: "col-span-1 row-span-1",
    },
    {
      id: 4,
      title: "ICT",
      subtitle: "Information & Communication Technology",
      image: ICT,
      className: "col-span-1 row-span-1",
    },
  ];

  return (
    <div>
      <Header />
      <section className="relative min-h-screen bg-gradient-to-b from-[#5b5853] to-[#1a1a1a] py-16 px-6">
        {/* Background overlay */}
        <div className="absolute inset-0 bg-black/40"></div>

        <div
          className="relative z-10 max-w-7xl mx-auto pt-[2rem] md:pt-[4rem]"
          data-aos="fade-up"
        >
          {/* Header Section */}
          <div className="text-center mb-16">
            <h1 className="text-3xl lg:text-5xl font-bold text-white mb-6 mt-10">
              Your Gateway to Successful Investment in KSA
            </h1>
            <p className="text-lg md:text-xl text-[#E5E5E5] max-w-2xl mx-auto leading-relaxed font-light">
              To be the leading facilitator of foreign investment and business
              expansion into Saudi Arabia
            </p>
          </div>

          {/* Investment Opportunities Section */}
          <div className="mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-12">
              Investment Opportunities
            </h2>

            {/* Grid Layout - Exact placement from image */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-24 mx-auto">
              {/* Left Column */}
              <div className="space-y-8">
                {/* Manufacturing Card - Top Left */}
                <div
                  className="group relative overflow-hidden rounded-[40px] bg-gradient-to-br from-[#6B5B47]/90 to-[#8B7355]/80 backdrop-blur-sm transition-all duration-300 hover:scale-105"
                  data-aos="fade-up"
                >
                  <div className="relative overflow-hidden flex items-center justify-center">
                    <img
                      src={investmentOpportunities[0].image}
                      alt="Manufacturing"
                      className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  </div>
                </div>

                {/* Construction Card - Bottom Left */}
                <div
                  className="group relative overflow-hidden rounded-[40px] bg-gradient-to-br from-[#6B5B47]/90 to-[#8B7355]/80 backdrop-blur-sm transition-all duration-300 hover:scale-105"
                  data-aos="fade-up"
                >
                  <div className="relative overflow-hidden flex items-center justify-center">
                    <img
                      src={investmentOpportunities[2].image}
                      alt="Manufacturing"
                      className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  </div>
                </div>
              </div>

              {/* Right Column */}
              <div className="space-y-8 mt-0 md:mt-[5rem]">
                {/* Real Estate Card - Top Right */}
                <div
                  className="group relative overflow-hidden rounded-[40px] bg-gradient-to-br from-[#6B5B47]/90 to-[#8B7355]/80 backdrop-blur-sm transition-all duration-300 hover:scale-105"
                  data-aos="fade-up"
                >
                  <div className="relative overflow-hidden flex items-center justify-center">
                    <img
                      src={investmentOpportunities[1].image}
                      alt="Manufacturing"
                      className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  </div>
                </div>

                {/* ICT Card - Bottom Right */}
                <div
                  className="group relative overflow-hidden rounded-[40px] bg-gradient-to-br from-[#6B5B47]/90 to-[#8B7355]/80 backdrop-blur-sm transition-all duration-300 hover:scale-105"
                  data-aos="fade-up"
                >
                  <div className="relative overflow-hidden flex items-center justify-center">
                    <img
                      src={investmentOpportunities[3].image}
                      alt="Manufacturing"
                      className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <PartnershipSection />
      <ProjectInquirySection />
      <Footer />
    </div>
  );
};

export default InvestmentOpportunities;
